angular
  .module('pb.core.user')

  .directive('pbCanCreate', [
    'LoggedUser',

    function(LoggedUser) {
      return {
        restrict: 'A',
        priority: 999,
        link: function(scope, element, attrs) {
          var resourceType = attrs.pbCanCreate,
            resources = LoggedUser.get().getResources();

          if (!resourceType) {
            return;
          }

          if (
            typeof resources !== 'object' ||
            !resources[resourceType] ||
            !angular.isArray(resources[resourceType])
          ) {
            element.remove();
            return;
          }

          if (resources[resourceType].indexOf('create') >= 0) {
            //remove the attribute to avoid infinite loop
            element.removeAttr('pb-can-create');
          } else {
            element.remove();
          }
        }
      };
    }
  ]);
